// extracted by mini-css-extract-plugin
export default {"root":"SectionHero_root__zeQDy","searchBar":"SectionHero_searchBar__6JOEm"};